export function EmptyState({ icon: Icon, title, hint, action, testId, compact = false }) {
  return (
    <div
      data-testid={testId}
      style={{
        marginTop: compact ? 12 : 18,
        padding: compact ? "18px 16px" : "28px 20px",
        border: "1px dashed var(--cardhover)",
        borderRadius: 12,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,
        background: "rgba(24, 24, 27,0.025)",
      }}
    >
      {Icon && (
        <div style={{ width: 42, height: 42, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(24, 24, 27,0.10)", color: "var(--orange)" }}>
          <Icon size={20} />
        </div>
      )}
      <div className="font-display" style={{ fontSize: 14, fontWeight: 600, color: "var(--tprimary)", letterSpacing: "-0.01em" }}>{title}</div>
      {hint && <div className="font-body" style={{ fontSize: 12.5, color: "var(--tsecondary)", lineHeight: 1.55, maxWidth: 300 }}>{hint}</div>}
      {action && <div style={{ marginTop: 4 }}>{action}</div>}
    </div>
  );
}
